// import "../css/styles.css"
import '../sass/main.scss'
import '@popperjs/core';
import 'bootstrap'
import 'lite-youtube-embed';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import jQuery from "jquery";
// import 'intersection-observer'
// import '@fancyapps/fancybox';
// import { jQueryScrollTo } from '@/resources/assets/js/modules/utils';
import './modules/iobserver';
// import './modules/input-datetime';
import './modules/sector-selection';
import './modules/woocommerce';
import '@/node_modules/swiper/swiper.min.css';
import '@/node_modules/swiper/modules/effect-fade.min.css';

import '@/partials/components/header-site/header-site'
import '@/partials/components/header-hero/header-hero'
import '@/partials/components/trustpilot-slider/trustpilot-slider'
import '@/partials/components/align-media/align-media'
import '@/partials/components/related-links/related-links'
import '@/partials/components/grid-cards/grid-cards.jsx';
import '@/partials/components/header-solutions/header-solutions'
import '@/partials/components/interactive-house/interactive-house.jsx'
import '@/partials/components/gallery-products/gallery-products'
import '@/partials/components/product-features/product-features'
import '@/partials/components/info-cards/info-cards'
import '@/partials/components/posts-feed/posts-feed'
import '@/partials/components/big-numbers/big-numbers'
import '@/partials/components/testimonials-slider/testimonials-slider'
import '@/partials/components/promo-banner/promo-banner'
import '@/partials/components/promo-area/promo-area'
import '@/partials/components/cart-recommendations/cart-recommendations'
import '@/partials/components/accordion/accordion'
import '@/partials/components/faq-accordion/faq-accordion'
import '@/partials/components/scrolling-section/scrolling-section'
import '@/partials/components/contact-section/contact-section'
import '@/partials/components/quiz/quiz'


jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, { passive: true });
  }
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, { passive: true });
  }
};

// check if vite is in dev mode
if (import.meta.env.DEV) {
  console.log('Dev mode...');
}

